import React from 'react';

import { Anchor, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';

import { getSourceIcon } from './getSourceIcon.tsx';
import type { Source } from './PopularQuestions.tsx';

export const SourceItem = ({ source }: { source: Source }) => {
	const content = source?.content;

	return (
		<Anchor href={content?.links?.webui ?? '#'} rel="noopener noreferrer" xcss={styles.noUnderline}>
			<Stack space="space.075">
				<Inline alignBlock="center" space="space.100">
					{getSourceIcon({ url: undefined, completeKey: content?.embeddedProduct })}
					<Text weight="medium" maxLines={1}>
						{content?.title}
					</Text>
				</Inline>
				{content?.excerpt && (
					<Text size="small" color="color.text.subtle" maxLines={2}>
						{content.excerpt}
					</Text>
				)}
			</Stack>
		</Anchor>
	);
};

const styles = cssMap({
	noUnderline: { textDecoration: 'none' },
});
